import axios from "axios";



const API_BASE_URL =

  process.env.REACT_APP_API_URL || "https://api.bsangam.com";



const DONATION_BASE_URL = `${API_BASE_URL}/donations`;

const BILLING_FINANCE_BASE_URL = `${API_BASE_URL}/billing-finance`;

const TRANSACTION_BASE_URL = `${BILLING_FINANCE_BASE_URL}/transactions`;

const PAYMENT_ORDER_BASE_URL = `${BILLING_FINANCE_BASE_URL}/payment-orders`;

const PAYMENT_METHOD_BASE_URL = `${API_BASE_URL}/billing/payment_methods`;



const appendFormData = (

  formData: FormData,

  payload: Record<string, any>

) => {

  Object.entries(payload).forEach(([key, value]) => {

    if (

      value !== undefined &&

      value !== null &&

      value !== ""

    ) {

      formData.append(key, String(value));

    }

  });

};



// ==========================

// GET DONATION CAMPAIGNS

// ==========================

export const getDonationCampaignsApi = async (

  client_id: number | string

) => {

  try {

    const res = await axios.get(

      `${DONATION_BASE_URL}/campaigns/${client_id}`

    );



    return res.data;

  } catch (error: any) {

    return {

      status: false,

      data: [],

      message:

        error?.response?.data?.message ||

        "Failed to fetch donation campaigns",

    };

  }

};



// ==========================

// GET MEMBER DONATION HISTORY

// ==========================

export const getDonationTransactionsApi = async (payload: {

  client_id: number | string;

  contact_id?: number | string | null;

  user_id?: number | string | null;

  page?: number;

  limit?: number;

}) => {

  try {

    const res = await axios.get(TRANSACTION_BASE_URL, {

      params: {

        client_id: payload.client_id,

        contact_id: payload.contact_id || undefined,

        user_id: payload.user_id || undefined,

        transaction_type: "donation",

        direction: "credit",

        payment_status: "success",

        page: payload.page || 1,

        limit: payload.limit || 20,

      },

    });



    return res.data;

  } catch (error: any) {

    return {

      status: false,

      data: [],

      message:

        error?.response?.data?.message ||

        "Failed to fetch donation transactions",

    };

  }

};



// ==========================

// GET SINGLE POST DETAILS

// ==========================

export const getPostByIdApi = async (

  post_id: number | string

) => {

  try {

    const res = await axios.get(

      `${API_BASE_URL}/posts/${post_id}`

    );



    return res.data;

  } catch (error: any) {

    return {

      status: false,

      data: null,

      message:

        error?.response?.data?.message ||

        "Failed to fetch post",

    };

  }

};



// ==========================

// GET SUCCESSFUL DONATIONS BY POST

// ==========================

export const getDonationDetailsByPostApi = async (
  post_id: number | string,
  _client_id?: number | string
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/transaction-history/donation-post/${encodeURIComponent(String(post_id))}`
    );
    return res.data;
  } catch (error: any) {
    console.error("Fetch donations by post failed:", error?.response?.data || error);
    return {
      success: false,
      status: false,
      data: [],
      message: error?.response?.data?.message || "Failed to fetch donation details",
    };
  }
};


// ==========================
// GET ACTIVE PAYMENT METHODS

// ==========================

export const getPaymentMethodsApi = async () => {

  try {

    const res = await axios.get(PAYMENT_METHOD_BASE_URL);

    return res.data;

  } catch (error: any) {

    return {

      status: false,

      data: [],

      message:

        error?.response?.data?.message ||

        "Failed to fetch payment methods",

    };

  }

};



// ==========================

// CREATE CASHFREE SESSION HELPER

// ==========================

const createPaymentSessionApi = async (

  orderId: number | string,

  payload: Record<string, any>,

  orderData: Record<string, any> = {}

) => {

  try {

    const sessionFormData = new FormData();



    appendFormData(sessionFormData, {

      return_url: payload.return_url,

      notify_url: payload.notify_url,



      customer_name:

        payload.payer_name ||

        payload.donor_name ||

        null,



      customer_phone:

        payload.payer_mobile ||

        payload.mobile ||

        null,



      customer_email:

        payload.payer_email ||

        payload.email ||

        null,

    });



    const sessionResponse = await axios.post(

      `${PAYMENT_ORDER_BASE_URL}/${orderId}/session`,

      sessionFormData

    );



    const sessionResult = sessionResponse.data;



    if (

      sessionResult?.success !== true &&

      sessionResult?.status !== true

    ) {

      return {

        status: false,

        message:

          sessionResult?.message ||

          "Failed to create Cashfree session",

        data: {

          order_id: orderId,

          retryable: true,

        },

      };

    }



    const sessionData =

      sessionResult?.data ||

      sessionResult;



    if (!sessionData?.payment_session_id) {

      return {

        status: false,

        message:

          "Cashfree payment session ID was not returned",

        data: {

          order_id: orderId,

          retryable: true,

        },

      };

    }



    return {

      status: true,

      message:

        sessionResult?.message ||

        "Payment session created successfully",

      data: {

        order_id: orderId,



        order_code:

          orderData?.order_code ||

          sessionData?.order_code ||

          null,



        payment_session_id:

          sessionData.payment_session_id,



        cf_order_id:

          sessionData?.cf_order_id ||

          null,



        order_status:

          sessionData?.order_status ||

          "initiated",



        gateway:

          sessionData?.gateway ||

          orderData?.gateway ||

          null,



        order:

          orderData,



        session:

          sessionData,

      },

    };

  } catch (error: any) {

    console.error(

      "Create payment session error:",

      error?.response?.data ||

        error

    );



    return {

      status: false,

      message:

        error?.response?.data?.message ||

        error?.response?.data?.error?.message ||

        error?.message ||

        "Unable to create payment session",

      data: {

        order_id: orderId,

        retryable: true,

      },

    };

  }

};



// ==========================

// CREATE PAYMENT ORDER + CASHFREE SESSION

// ==========================

export const createDonationApi = async (

  payload: Record<string, any>

) => {

  try {

    const orderFormData = new FormData();

    const amount = Number(payload.amount || 0);



    appendFormData(orderFormData, {

      transaction_type:

        payload.transaction_type ||

        "donation",



      transaction_type_key:

        payload.transaction_type_key ||

        "donation",



      client_id: payload.client_id,

      post_id: payload.post_id,



      user_id:

        payload.user_id || null,



      contact_id:

        payload.contact_id || null,



      payer_type:

        payload.payer_type ||

        (payload.user_id

          ? "user"

          : payload.contact_id

            ? "contact"

            : "guest"),



      payer_user_id:

        payload.payer_user_id ||

        payload.user_id ||

        null,



      payer_contact_id:

        payload.payer_contact_id ||

        payload.contact_id ||

        null,



      payer_client_id:

        payload.payer_client_id ||

        null,



      payer_name:

        payload.payer_name ||

        payload.donor_name ||

        null,



      payer_email:

        payload.payer_email ||

        payload.email ||

        null,



      payer_mobile:

        payload.payer_mobile ||

        payload.mobile ||

        null,



      donor_name:

        payload.donor_name ||

        payload.payer_name ||

        null,



      mobile:

        payload.mobile ||

        payload.payer_mobile ||

        null,



      email:

        payload.email ||

        payload.payer_email ||

        null,



      address:

        payload.address || null,



      reference_type:

        payload.reference_type ||

        "post",



      reference_id:

        payload.reference_id ||

        payload.post_id,



      amount,



      payable_amount:

        Number(

          payload.payable_amount ||

            amount

        ),



      tax_amount:

        Number(

          payload.tax_amount || 0

        ),



      discount_amount:

        Number(

          payload.discount_amount || 0

        ),



      currency:

        payload.currency || "INR",



      payment_method_id:

        payload.payment_method_id,



      source_app:

        payload.source_app ||

        "public_web",



      source_platform:

        payload.source_platform ||

        "web",



      visibility:

        payload.visibility ||

        "anonymous",



      donation_source:

        payload.donation_source ||

        (payload.user_id

          ? "member"

          : "guest"),



      remarks:

        payload.remarks || null,



      return_url:

        payload.return_url,



      notify_url:

        payload.notify_url,

    });



    const orderResponse = await axios.post(

      PAYMENT_ORDER_BASE_URL,

      orderFormData

    );



    const orderResult =

      orderResponse.data;



    if (

      orderResult?.success !== true &&

      orderResult?.status !== true

    ) {

      return {

        status: false,

        data: null,

        message:

          orderResult?.message ||

          "Failed to create payment order",

      };

    }



    const orderData =

      orderResult?.data || {};



    const orderId =

      orderData?.order_id ||

      orderResult?.order_id;



    if (!orderId) {

      return {

        status: false,

        data: null,

        message:

          "Payment order ID was not returned",

      };

    }



    return createPaymentSessionApi(

      orderId,

      payload,

      orderData

    );

  } catch (error: any) {

    console.error(

      "Create donation payment error:",

      error?.response?.data ||

        error

    );



    return {

      status: false,

      data: null,

      message:

        error?.response?.data?.message ||

        error?.response?.data?.error?.message ||

        error?.message ||

        "Unable to start donation payment",

    };

  }

};



// ==========================

// RETRY CASHFREE SESSION USING SAME ORDER

// ==========================

export const retryPaymentSessionApi = async (

  orderId: number | string,

  payload: Record<string, any>

) => {

  return createPaymentSessionApi(

    orderId,

    payload

  );

};



// ==========================

// GET PAYMENT ORDER STATUS

// ==========================

export const getPaymentOrderStatusApi = async (

  order_id: number | string

) => {

  try {

    const res = await axios.get(

      `${PAYMENT_ORDER_BASE_URL}/${order_id}/status`

    );



    return res.data;

  } catch (error: any) {

    return {

      status: false,

      data: null,

      message:

        error?.response?.data?.message ||

        "Failed to fetch payment status",

    };

  }

};










